export default __webpack_public_path__ + "static/media/sand-blasting-icon-dark.03c82f5b.svg";